import React from "react";
import ToggleWrapper from "../../../ToggleWrapper";
import BaseDropdown from "@reusables/dropdowns/BaseDropdown";
import {useTranslation} from "react-i18next";
import {ProductSchemeTyping} from "../../../types";
import {Controller, useFormContext} from "react-hook-form";
import {useGetModuleTaxesQuery} from "@redux/features/taxes/taxesApi";


export default function TaxDropdown(){
    const { t } = useTranslation("", { keyPrefix: "products" });

    const {data: options, isLoading: optionsLoading } = useGetModuleTaxesQuery("product");

    const {control} = useFormContext<ProductSchemeTyping>();

    return (
      <>
          <ToggleWrapper label={t("general.fields.defaultTax.label")} fieldKey="tax">
              <Controller
                  name="general.tax"
                  control={control}
                  render={({ field, fieldState }) => (
                      <BaseDropdown
                          {...field}
                          error={fieldState.error}
                          placeholder={t("general.fields.defaultTax.placeholder")}
                          options={options}
                          getter={{
                              key: opt => opt.id,
                              label: opt => `${opt.rate}%`,
                              caption: opt => opt.name
                          }}
                          isLoading={optionsLoading}
                      />
                  )}
              />
          </ToggleWrapper>
      </>
    )
}